module.exports = __webpack_public_path__ + "img/product-ketang-zzct-02.82a65cfd.png";